import angular from "angular";
import uiRouter from "angular-ui-router";
import "ngstorage";
import security from "./security";
import auth from "./auth";
import env from "./env";

export default class IterableService {
  constructor($http, $localStorage, $state, $q, SecurityService, AuthService, EnvService, $rootScope, $timeout) {
    this.$http = $http;
    this.$localStorage = $localStorage;
    this.$state = $state;
    this.$q = $q;
    this.$auth = AuthService;
    this.$security = SecurityService;
    this.$env = EnvService;
    this.$rootScope = $rootScope;
    this.$timeout = $timeout;
  }

  set_data(board_params, job, user, type) {
    var _this = this;

    let jobName = null;

    if (type === "apply") {
      jobName = "Web App Job Apply";
    } else {
      jobName = "Web App Tracking";
    }

    let data = {};

    data.email = user.email;
    data.eventName = jobName;
    data.createdAt = moment(job.dateCreated).unix();
    data.dataFields = {};
    data.dataFields.jobble_id = job.id;
    data.dataFields.jobble_type_id = job.jobbleType.id;
    data.dataFields.jobble_type_name = job.jobbleType.name;

    return data;
  }

  track_jobble_view(data) {
    var _this = this;

    let key = _this.$env.EnvironmentConfig.iterable_api_key;
    let req = {
      method: "POST",
      url: "https://api.iterable.com:443/api/events/track?api_key=" + key,
      data: data,
    };
    return _this.$http(req);
  }

  track_jobble_apply(data) {
    var _this = this;

    let key = _this.$env.EnvironmentConfig.iterable_api_key;

    let req = {
      method: "POST",
      url: "https://api.iterable.com:443/api/events/track?api_key=" + key,
      data: data,
    };

    return _this.$http(req);
  }
}

IterableService.$inject = ["$http", "$localStorage", "$state", "$q", "security", "auth", "env", "$rootScope", "$timeout"];



// WEBPACK FOOTER //
// ./client/app/services/iterable.js